import {
  GET_QC_STAGE,
  GET_QC_STAGE_EXPORT,
  GET_QC_STAGE_FILTER_ACTIVITY,
  //qc
  GET_QC_CHECK_POINT,
  GET_QC_CHECK_POINT_EXPORT,
  GET_QC_CHECK_POINT_OPTION,
  GET_QC_CHECK_POINT_OPTION_EXPORT,
  GET_QC_CHECK_POINT_OPTION_MAP,
  GET_QC_CHECK_POINT_OPTION_MAP_EXPORT,
  GET_QC_STAGE_CHECK_POINT_MAP,
  GET_QC_STAGE_CHECK_POINT_MAP_EXPORT,
  GET_QC_REQUEST,
  GET_QC_REQUEST_EXPORT,
  CREATE_QC_REQUEST,
  GET_ACTUAL_ENTRY_FOR_QC_REQUEST,
  GET_QC_REQUEST_DETAILS,
  GET_ACTIVITY_FOR_QC_REQUEST,
  GET_QC_CHECK_POINT_BY_STAGE,
  GET_QC_REQUEST_REVIEW,
  GET_QC_REQUEST_APPROVE,
  GET_QC_REQUEST_REVIEW_EXPORT,
  GET_QC_REQUEST_APPROVE_EXPORT,
  GET_QC_INSTRUCTION,
  GET_QC_INSTRUCTION_EXPORT,
  GET_INSTRUCTION_FILTER_PROJECT,
  GET_INSTRUCTION_FILTER_ASSIGNED_TO,
  GET_INSTRUCTION_FILTER_RAISED_BY,
  GET_QC_INSTRUCTION_DETAIL,
  GET_QC_INSTRUCTION_FOR_QC,
  GET_QC_INSPECTION_FILTER_PROJECT,
  GET_QC_INSPECTION_FILTER_PROCESS,
  GET_QC_INSPECTION_FILTER_ACTIVITY,
  GET_WBS_FOR_QC_REQUEST,
  GET_LOCATION_FOR_QC,
  GET_ASSIGNEE_FOR_INSTRUCTION,
  GET_QC_REQUEST_ITEM1,
  GET_QC_INSPECTION_REVIEW_FILTER_PROJECT,
  GET_QC_INSPECTION_REVIEW_FILTER_PROCESS,
  GET_QC_INSPECTION_REVIEW_FILTER_ACTIVITY,
  //QC WALKTHROUGH
  GET_QC_WALKTHROUGH,
  GET_QC_WALKTHROUGH_EXPORT,
  GET_QC_WALKTHROUGH_DETAIL,
  GET_QC_WALKTHROUGH_FILTER_PROJECT
} from "./types";

const initialStateChart = {
  labels: [],
  datasets: []
};
const initialState = {
  //QC STAGE
  getQcStages: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcStagesExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcStagesFilterActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //qc
  getQcCheckPoint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcCheckPointExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcCheckPointOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcCheckPointOptionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcCheckPointOptionMap: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcCheckPointOptionMapExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcStageCheckPointMap: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcStageCheckPointMapExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //qc
  createQcRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequestExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActualEntryForQcRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequestDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActivityForQcRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcCheckPointByStage: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequestReview: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequestApprove: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequestReviewExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequestApproveExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInstruction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInstructionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInstructionFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInstructionFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInstructionFilterRaisedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInstructionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInstructionForQc: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionFilterActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getWbsForQcRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLocationForQc: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssigneeForInstruction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcRequestItem1: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionReviewFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionReviewFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionReviewFilterActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWalkthrough: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWalkthroughExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWalkthroughDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWalkthroughFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};
const QC_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    //QC STAGE
    case GET_QC_STAGE:
      return Object.assign({}, state, {
        getQcStages: payload
      });
    case GET_QC_STAGE_EXPORT:
      return Object.assign({}, state, {
        getQcStagesExport: payload
      });
    case GET_QC_STAGE_FILTER_ACTIVITY:
      return Object.assign({}, state, {
        getQcStagesFilterActivity: payload
      });
    //qc
    case GET_QC_CHECK_POINT:
      return Object.assign({}, state, {
        getQcCheckPoint: payload
      });
    case GET_QC_CHECK_POINT_EXPORT:
      return Object.assign({}, state, {
        getQcCheckPointExport: payload
      });
    case GET_QC_CHECK_POINT_OPTION:
      return Object.assign({}, state, {
        getQcCheckPointOption: payload
      });
    case GET_QC_CHECK_POINT_OPTION_EXPORT:
      return Object.assign({}, state, {
        getQcCheckPointOptionExport: payload
      });
    case GET_QC_CHECK_POINT_OPTION_MAP:
      return Object.assign({}, state, {
        getQcCheckPointOptionMap: payload
      });
    case GET_QC_CHECK_POINT_OPTION_MAP_EXPORT:
      return Object.assign({}, state, {
        getQcCheckPointOptionMapExport: payload
      });
    case GET_QC_STAGE_CHECK_POINT_MAP:
      return Object.assign({}, state, {
        getQcStageCheckPointMap: payload
      });
    case GET_QC_STAGE_CHECK_POINT_MAP_EXPORT:
      return Object.assign({}, state, {
        getQcStageCheckPointMapExport: payload
      });
    //qc
    case CREATE_QC_REQUEST:
      return Object.assign({}, state, {
        createQcRequest: payload
      });
    case GET_QC_REQUEST:
      return Object.assign({}, state, {
        getQcRequest: payload
      });
    case GET_QC_REQUEST_EXPORT:
      return Object.assign({}, state, {
        getQcRequestExport: payload
      });
    case GET_ACTUAL_ENTRY_FOR_QC_REQUEST:
      return Object.assign({}, state, {
        getActualEntryForQcRequest: payload
      });
    case GET_QC_REQUEST_DETAILS:
      return Object.assign({}, state, {
        getQcRequestDetail: payload
      });
    case GET_ACTIVITY_FOR_QC_REQUEST:
      return Object.assign({}, state, {
        getActivityForQcRequest: payload
      });
    case GET_QC_CHECK_POINT_BY_STAGE:
      return Object.assign({}, state, {
        getQcCheckPointByStage: payload
      });
    case GET_QC_REQUEST_REVIEW:
      return Object.assign({}, state, {
        getQcRequestReview: payload
      });
    case GET_QC_REQUEST_APPROVE:
      return Object.assign({}, state, {
        getQcRequestApprove: payload
      });
    case GET_QC_REQUEST_REVIEW_EXPORT:
      return Object.assign({}, state, {
        getQcRequestReviewExport: payload
      });
    case GET_QC_REQUEST_APPROVE_EXPORT:
      return Object.assign({}, state, {
        getQcRequestApproveExport: payload
      });
    case GET_QC_INSTRUCTION:
      return Object.assign({}, state, {
        getQcInstruction: payload
      });
    case GET_QC_INSTRUCTION_EXPORT:
      return Object.assign({}, state, {
        getQcInstructionExport: payload
      });
    case GET_INSTRUCTION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcInstructionFilterProject: payload
      });
    case GET_INSTRUCTION_FILTER_ASSIGNED_TO:
      return Object.assign({}, state, {
        getQcInstructionFilterAssignedTo: payload
      });
    case GET_INSTRUCTION_FILTER_RAISED_BY:
      return Object.assign({}, state, {
        getQcInstructionFilterRaisedBy: payload
      });
    case GET_QC_INSTRUCTION_DETAIL:
      return Object.assign({}, state, {
        getQcInstructionDetail: payload
      });
    case GET_QC_INSTRUCTION_FOR_QC:
      return Object.assign({}, state, {
        getQcInstructionForQc: payload
      });
    case GET_QC_INSPECTION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcInspectionFilterProject: payload
      });
    case GET_QC_INSPECTION_FILTER_PROCESS:
      return Object.assign({}, state, {
        getQcInspectionFilterProcess: payload
      });
    case GET_QC_INSPECTION_FILTER_ACTIVITY:
      return Object.assign({}, state, {
        getQcInspectionFilterActivity: payload
      });
    case GET_WBS_FOR_QC_REQUEST:
      return Object.assign({}, state, {
        getWbsForQcRequest: payload
      });
    case GET_LOCATION_FOR_QC:
      return Object.assign({}, state, {
        getLocationForQc: payload
      });
    case GET_ASSIGNEE_FOR_INSTRUCTION:
      return Object.assign({}, state, {
        getAssigneeForInstruction: payload
      });
    case GET_QC_REQUEST_ITEM1:
      return Object.assign({}, state, {
        getQcRequestItem1: payload
      });
    case GET_QC_INSPECTION_REVIEW_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcInspectionReviewFilterProject: payload
      });
    case GET_QC_INSPECTION_REVIEW_FILTER_PROCESS:
      return Object.assign({}, state, {
        getQcInspectionReviewFilterProcess: payload
      });
    case GET_QC_INSPECTION_REVIEW_FILTER_ACTIVITY:
      return Object.assign({}, state, {
        getQcInspectionReviewFilterActivity: payload
      });
    case GET_QC_WALKTHROUGH:
      return Object.assign({}, state, {
        getQcWalkthrough: payload
      });
    case GET_QC_WALKTHROUGH_EXPORT:
      return Object.assign({}, state, {
        getQcWalkthroughExport: payload
      });
    case GET_QC_WALKTHROUGH_DETAIL:
      return Object.assign({}, state, {
        getQcWalkthroughDetail: payload
      });
    case GET_QC_WALKTHROUGH_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcWalkthroughFilterProject: payload
      });

    default:
      return state;
  }
};
export default QC_reducer;
